import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { useStore } from "@/store"
import { useShallow } from "zustand/shallow"
import { Copy } from "lucide-react"
import { createFileRoute } from "@tanstack/react-router"
import { useEffect } from "react"
import { toast } from "sonner"
import { copyTextToClipboard } from "@/lib/utils"

const SUPPORT_EMAIL = "merchant-support@prorouting.in"

export const Route = createFileRoute('/_auth/support')({
  component: RouteComponent,
})

function RouteComponent() {
  const { accountId, setPage } = useStore(useShallow(state => ({
    accountId: state.selectedAccount.id,
    setPage: state.setPage,
  })))

  useEffect(() => {
    setPage('Support')
  }, [setPage])

  // const mailtoLink = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(`Support for account ${accountId}`)}&body=${encodeURIComponent(`Hi, I need support related to my account: ${accountId}. My issue is: `)}`

  const copyEmail = async () => {
    const didCopy = await copyTextToClipboard(SUPPORT_EMAIL)
    if (didCopy) {
      toast.success("Email copied")
    } else {
      toast.error("Unable to copy email")
    }
  }

  return (
    <div className="w-full lg:px-32 xl:px-60 px-5 py-6">
      <Card className="p-6 space-y-4">
        <h1 className="text-xl font-semibold">Support</h1>
        <p className="text-base">
          For all order related issues, please raise the issue so that the Logistics Service Providers can respond
        </p>
        <div className="flex items-center gap-3">
        <p className="text-base">
          For any other issues, please write to us at <b>{SUPPORT_EMAIL} </b>and quote your account Id <b>{accountId}</b>
        </p>
          <Button variant="outline" size="icon" aria-label="Copy support email" onClick={copyEmail}>
            <Copy className="h-4 w-4" />
          </Button>
        </div>
      </Card>
    </div>
  )
}
